import { Plural, Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconCloth from '@/icons/Cloth.svg';

type Activity = ActivityOfType<'client_pickup_completed'>;

type ActivityWithArticle = Activity & {
  articleId: NonNullable<Activity['articleId']>;
  article: NonNullable<Activity['articleId']>;
};

export const ClientPickupCompletedActivity = ({
  activity,
  nbOfArticles,
  displayArticleName,
}: {
  activity: Activity;
  nbOfArticles: number;
  displayArticleName: boolean;
}) => {
  const message = activity.article ? (
    <BaseActivityText>
      <Trans id="activities.client_pickup_completed.picked-up-article">
        <strong>The client</strong> picked up the item
      </Trans>

      <BaseActivityArticleName
        activity={activity as ActivityWithArticle} // This is necessary else TS does not understand that we checked that article is present so we enforce the type where article is not optional.
        displayArticleName={displayArticleName}
      />
    </BaseActivityText>
  ) : (
    <BaseActivityText>
      <Trans id="activities.client_pickup_completed.picked-up">
        <strong>The client</strong> picked up the{' '}
        <Plural value={nbOfArticles ?? 0} one="item" other="items" />
      </Trans>
    </BaseActivityText>
  );

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconCloth />}
      message={message}
    />
  );
};
